import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import {
  Breadcrumbs,
  Typography,
} from '@material-ui/core'

import Link from './Link'

class BreadcrumbContainer extends React.Component {
  static propTypes = {
    /* HOC/middleware props */
    items: PropTypes.array.isRequired,
  }

  static styles = () => ({
  })

  renderItem = ({ title, to }) => {
    if (to) {
      return <Link color="inherit" to={to} key={title}>{title}</Link>
    }
    return <Typography color="textPrimary" key={title}>{title}</Typography>
  }

  render() {
    return (
      <Breadcrumbs aria-label="breadcrumb">
        <Link to="/">Home</Link>
        {this.props.items.map(this.renderItem)}
      </Breadcrumbs>
    )
  }
}

export default withStyles(BreadcrumbContainer.styles)(BreadcrumbContainer)
